/**
 * Lightweight logger used in place of bare `console.*` calls inside catch
 * blocks. Suppresses output in production builds so the browser console stays
 * clean for end-users while preserving full visibility during development.
 *
 * Usage:
 *   import logger from "@/lib/logger";
 *   logger.warn("Something non-fatal:", err?.message);
 */
const isDev = process.env.NODE_ENV !== "production";

/* eslint-disable no-console */
const logger = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};
/* eslint-enable no-console */

export default logger;
